import { render, staticRenderFns } from "./clbjtj.vue?vue&type=template&id=33668d38&scoped=true"
import script from "./clbjtj.vue?vue&type=script&lang=js"
export * from "./clbjtj.vue?vue&type=script&lang=js"
import style0 from "./clbjtj.vue?vue&type=style&index=0&id=33668d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33668d38",
  null
  
)

export default component.exports